'use client';
import React, { useEffect, useState } from 'react';
import { WishlistItems as Shared } from '@launchstore/shared-puck';
import { usePuckContext } from '@/components/puck/PuckContextProvider';

const SharedRender = (Shared as any).render;

interface WishlistItemRaw {
  id: string;
  variant_id?: string;
  product_id?: string;
  product?: {
    id: string;
    title: string;
    handle?: string;
    thumbnail?: string;
    variants?: Array<{ id: string; title?: string }>;
  };
  variant?: { id: string; title?: string };
  created_at?: string;
}

const mapItem = (raw: WishlistItemRaw) => {
  const variantId = raw.variant_id || raw.variant?.id;
  const productTitle = raw.product?.title ?? '';
  const variantTitle = raw.variant?.title;
  return {
    id: raw.id,
    variantId: variantId ?? '',
    productTitle,
    variantTitle,
    thumbnail: raw.product?.thumbnail,
    productHandle: raw.product?.handle,
  };
};

/**
 * Storefront WishlistItems — fetches the customer's wishlist from
 * /api/wishlist/items (assumes the API uses cookies for auth). Falls
 * back to the shared MOCK only in editor preview.
 */
function WishlistItemsImpl(props: any) {
  const { context } = usePuckContext() as any;
  const customer = context?.customer;
  const [items, setItems] = useState<any[] | undefined>(undefined);

  useEffect(() => {
    let mounted = true;
    if (!customer?.id) {
      setItems(undefined);
      return;
    }
    (async () => {
      try {
        const res = await fetch('/api/wishlist/items', { credentials: 'include' });
        if (!res.ok) {
          if (mounted) setItems(undefined);
          return;
        }
        const data = await res.json();
        const list: WishlistItemRaw[] = data.items || data.wishlist_items || [];
        if (mounted) setItems(list.map(mapItem));
      } catch {
        if (mounted) setItems(undefined);
      }
    })();
    return () => { mounted = false; };
  }, [customer?.id]);

  return <SharedRender {...props} items={items} />;
}

export const WishlistItems: any = {
  ...Shared,
  render: (props: any) => <WishlistItemsImpl {...props} />,
};
export default WishlistItems;
